import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useHistory} from 'src/rerouter/index';
import {
  BodyLarge,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  Dialog,
  DialogBody,
  DialogHeader,
  DialogFooter,
  DIALOG_SEMANTIC,
} from '@spaced-out/ui-design-system/lib/components/Dialog';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import css from './data-export-success-genesis.css';


export const ExportDefaultContent = () => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <>
      <BodyLarge color="secondary">{`${t(
        'When_your_requested_report_is_ready_for_download_you_will_receive_an_email_with_a_download_link',
        'When your requested report is ready for download, you will receive an email with a download link',
      )}. ${t(
        'While_estimated_times_are_varied_we_expect_it_will_be_ready_soon',
        'While estimated times are varied, we expect it will be ready soon',
      )}.`}</BodyLarge>

      <BodyLarge color="secondary">
        {`${t(
          'To_find_all_past_reports_navigate_to_the_Reports_tab_within_Settings',
          'To find all past reports, navigate to the Reports tab within Settings',
        )}.`}
        {`(${t('Settings', 'Settings')}`} &#8594;{' '}
        {`${t('Reports', 'Reports')})`}
      </BodyLarge>

      <BodyLarge color="secondary">{`${t(
        'If_you_do_not_receive_an_email_check_your_spam_folder_or_request_the_report_again',
        'If you do not receive an email, check your spam folder or request the report again',
      )}.`}</BodyLarge>
    </>
  );
};

export const ReportExportInit = ({
  CustomContent = <ExportDefaultContent />,
  handlePrimaryCta = () => {},
  handleSecondaryCta = () => {},
}: {
  CustomContent?: string | React.ReactNode;
  handlePrimaryCta?: () => void;
  handleSecondaryCta?: () => void;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const router = useHistory();
  const [showExportDialog, setShowExportDialog] = React.useState(true);

  return (
    <Dialog
      isOpen={showExportDialog}
      semantic={DIALOG_SEMANTIC.success}
      tapOutsideToClose
      classNames={{content: css.dialogContainer}}
    >
      <DialogHeader>
        <SubTitleLarge>
          {t('Request_Successful', 'Request Successful')}
        </SubTitleLarge>
      </DialogHeader>

      <DialogBody className={css.dialogBody}>{CustomContent}</DialogBody>

      <DialogFooter>
        <Button
          type="tertiary"
          isFluid
          onClick={() => {
            handleSecondaryCta();
            setShowExportDialog(false);
            router.push('/settings/reports');
          }}
        >
          {t('View_Reports', 'View Reports')}
        </Button>

        <Button
          type="primary"
          isFluid
          onClick={() => {
            handlePrimaryCta();
            setShowExportDialog(false);
          }}
        >
          {t('Okay', 'Okay')}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export const ReportExportSuccess = ({
  handlePrimaryCta = () => {},
  handleSecondaryCta = () => {},
}: {
  handlePrimaryCta?: () => void;
  handleSecondaryCta?: () => void;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const router = useHistory();
  const [showExportDialog, setShowExportDialog] = React.useState(true);

  return (
    <Dialog
      isOpen={showExportDialog}
      semantic={DIALOG_SEMANTIC.success}
      tapOutsideToClose
      classNames={{content: css.dialogContainer}}
    >
      <DialogHeader>
        <SubTitleLarge>{t('Report_Ready', 'Report Ready')}</SubTitleLarge>
      </DialogHeader>

      <DialogBody>
        <BodyLarge color="secondary">{`${t(
          'Your_report_is_ready',
          'Your report is ready.',
        )} ${t(
          'You_can_download_it_by_navigating_to_the_Reports_page',
          'You can download it by navigating to the Reports page',
        )}.`}</BodyLarge>
      </DialogBody>

      <DialogFooter>
        <Button
          type="tertiary"
          isFluid
          onClick={() => {
            handleSecondaryCta();
            setShowExportDialog(false);
            router.push('/settings/reports');
          }}
        >
          {t('View_Reports', 'View Reports')}
        </Button>

        <Button
          type="primary"
          isFluid
          onClick={() => {
            handlePrimaryCta();
            setShowExportDialog(false);
          }}
        >
          {t('Okay', 'Okay')}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
